"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomInput = exports.CustomSelect = exports.customInputStyles = void 0;
var React = __importStar(require("react"));
var react_select_1 = __importStar(require("react-select"));
var customStyles = {
    container: function (provided, state) { return (__assign({}, provided
    // maxHeight: '33px',
    )); },
    control: function (provided, state) { return (__assign(__assign({}, provided), { borderRadius: state.selectProps.menuIsOpen ? "1.5em 1.5em 0 0" : "2em", border: "1px solid #0f0f3c", minHeight: "29px", 
        // maxHeight: '33px',
        borderColor: "#0f0f3c", borderBottomColor: state.selectProps.menuIsOpen ? "tranparent" : "#0f0f3c" })); },
    menu: function (provided, state) { return (__assign(__assign({}, provided), { marginTop: 0, border: "1px solid #0f0f3c", borderTop: 0, borderRadius: "0 0 2em 2em", overflow: "hidden" })); },
    menuList: function (provided, state) { return (__assign(__assign({}, provided), { paddingTop: 0, paddingBottom: 0, borderTop: 0 })); },
    indicatorsContainer: function (provided, state) {
        return __assign(__assign({}, provided), { width: 30, 
            // height: 30,
            // display: state.selectProps.menuIsOpen ? 'none' : 'flex',
            transform: "rotate(" + (state.selectProps.menuIsOpen ? "90deg" : 0) + ")" });
    },
    option: function (provided, state) {
        var isLastOption = state.options[state.options.length - 1].value === state.data.value;
        return __assign(__assign({}, provided), { borderBottom: isLastOption ? 0 : "1px solid #fce3c9", backgroundColor: state.isSelected || state.isHovered ? "#fa3fb8" : "#fff", color: state.isSelected || state.isHovered ? "#fff" : "#0F0F3C", padding: ".5em 1em", borderBottomLeftRadius: isLastOption ? "1.5em" : 0, borderBottomRightRadius: isLastOption ? "1.5em" : 0, "&:hover": {
                backgroundColor: state.isSelected ? "#fa3fb8" : "#e1e1e3"
            } });
    },
    valueContainer: function (provided, state) { return (__assign({}, provided
    // maxHeight: '30px'
    )); },
    singleValue: function (provided, state) { return (__assign(__assign({}, provided), { width: "calc(100% - 8px)", left: "50%", paddingLeft: "1em", paddingRight: "1em", transform: "translate(-50%, -50%)", textAlign: "center" })); },
    clearIndicator: function (provided, state) { return (__assign(__assign({}, provided), { maxHeight: 30, padding: "5px 8px" })); },
    multiValue: function (provided) { return (__assign(__assign({}, provided), { height: "100%", margin: "0 2px 1px" })); }
};
var DropdownIndicator = function (props) {
    return (React.createElement(react_select_1.components.DropdownIndicator, __assign({}, props),
        React.createElement("div", { className: "ic-dropdown-indicator-container" },
            React.createElement("i", { className: "fas fa-angle-right" }))));
};
var ValueContainer = function (props) {
    return (React.createElement(react_select_1.components.ValueContainer, __assign({}, props),
        React.createElement("div", { className: "ic-value-container" }, props.children)));
};
exports.customInputStyles = {
    control: function (provided, state) { return (__assign(__assign({}, provided), { borderRadius: "2em", border: "2px solid #0f0f3c", borderColor: "#0f0f3c" })); }
};
exports.CustomSelect = function (props) {
    return (React.createElement(react_select_1.default, __assign({ styles: customStyles, dropdownAlign: { offset: [0, 0] }, components: {
            DropdownIndicator: DropdownIndicator,
            ValueContainer: ValueContainer,
            IndicatorSeparator: function () { return null; }
        } }, props)));
};
exports.CustomInput = function (props) {
    return (React.createElement(react_select_1.default, __assign({ components: {
            IndicatorSeparator: function () { return null; },
            Menu: function () { return null; }
        }, styles: exports.customInputStyles }, props)));
};
